const $ = window.jQuery;

$( '.iec-link-to-form a, .iec-link-to-form' ).click( function( event ) {

	event.preventDefault();

	// Account for fixed header
	let headerOffset = $( '.fl-page > header.fl-builder-content' ).height();

	// Scroll to the top of the visible form
	window.scrollTo( {
		left: 0,
		top: $( '.iec-request-more-information-form:visible' ).offset().top - headerOffset,
		behavior: 'smooth',
	} );

} );
